export default __webpack_public_path__ + "static/media/photoshop.fe6e4a73.png";